/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MEMBER" | "MODERATOR" | "QUESTION" | "REVIEW" | "STAFF" | "UNANSWERED" | "%future added value";
export type ModerationActionsContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly id: string;
    } | null;
    readonly body: string | null;
    readonly revision: {
        readonly id: string;
    } | null;
    readonly status: COMMENT_STATUS;
    readonly tags: ReadonlyArray<{
        readonly code: TAG;
    }>;
    readonly " $fragmentRefs": FragmentRefs<"CopyCommentEmbedCodeContainer_comment">;
    readonly " $refType": "ModerationActionsContainer_comment";
};
export type ModerationActionsContainer_comment$data = ModerationActionsContainer_comment;
export type ModerationActionsContainer_comment$key = {
    readonly " $data"?: ModerationActionsContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = [
        (v0 /*: any*/)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ModerationActionsContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentRevision",
                "kind": "LinkedField",
                "name": "revision",
                "plural": false,
                "selections": (v1 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CopyCommentEmbedCodeContainer_comment"
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '269aa5dc4f509305c8efa0f6ac44ebb4';
export default node;
